module.exports = __webpack_public_path__ + "static/media/cq_ko.aa040f6a.svg";